module.exports = __webpack_public_path__ + "static/media/icon-phone.3e01cb7c.svg";